import Text, {IProps as ITextProps} from './Text';

interface IProps extends ITextProps {}

export default function DescText({className, ...rest}: IProps) {
  return (
    <Text
      className={cn(
        'flex before:font-medium before:mr-4 before:content-["·"] before:block',
        className
      )}
      {...rest}
    />
  );
}
